/*
 * ATTENTION: The "eval" devtool has been used (maybe by default in mode: "development").
 * This devtool is neither made for production nor for readable output files.
 * It uses "eval()" calls to create a separate source file in the browser devtools.
 * If you are trying to read the output file, select a different devtool (https://webpack.js.org/configuration/devtool/)
 * or disable the default devtool with "devtool: false".
 * If you are looking for production-ready output files, see mode: "production" (https://webpack.js.org/configuration/mode/).
 */
/******/ (function() { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ "./src/scripts/sections/footer.js":
/*!****************************************!*\
  !*** ./src/scripts/sections/footer.js ***!
  \****************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

eval("{__webpack_require__.r(__webpack_exports__);\n/* harmony import */ var _styles_sections_footer_scss__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../styles/sections/footer.scss */ \"./src/styles/sections/footer.scss\");\n/* harmony import */ var _snippets_collapsible_content_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../snippets/collapsible-content.js */ \"./src/scripts/snippets/collapsible-content.js\");\n\n\nconst breakpoint = window.matchMedia('(max-width: 1200px)');\nconst breakpointChecker = () => {\n  if (breakpoint.matches === true) {\n    (0,_snippets_collapsible_content_js__WEBPACK_IMPORTED_MODULE_1__.collapsibleContent)('.footer__caption.collapsible', 'active', '.footer__list');\n  }\n};\nbreakpointChecker();\n\n//# sourceURL=webpack://fabric_and_stitchers/./src/scripts/sections/footer.js?\n}");

/***/ }),

/***/ "./src/scripts/snippets/collapsible-content.js":
/*!*****************************************************!*\
  !*** ./src/scripts/snippets/collapsible-content.js ***!
  \*****************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

eval("{__webpack_require__.r(__webpack_exports__);\n/* harmony export */ __webpack_require__.d(__webpack_exports__, {\n/* harmony export */   collapsibleContent: function() { return /* binding */ collapsibleContent; }\n/* harmony export */ });\nconst collapsibleContent = (buttonsSelector, className, contentSelector) => {\n  const buttons = document.querySelectorAll(buttonsSelector);\n  for (const button of buttons) {\n    const container = button.nextElementSibling.querySelector(contentSelector);\n    container.parentElement.style.setProperty('--true-height', `${container.offsetHeight}px`);\n    button.addEventListener('click', el => {\n      if (el.currentTarget.classList.contains(className)) {\n        el.currentTarget.nextElementSibling.style.height = '0';\n        el.currentTarget.classList.remove(className);\n      } else {\n        const container = el.currentTarget.nextElementSibling.querySelector(contentSelector);\n        el.currentTarget.classList.add(className);\n        el.currentTarget.nextElementSibling.style.height = `${container.offsetHeight}px`;\n      }\n    });\n  }\n};\n\n//# sourceURL=webpack://fabric_and_stitchers/./src/scripts/snippets/collapsible-content.js?\n}");

/***/ }),

/***/ "./src/styles/sections/footer.scss":
/*!*****************************************!*\
  !*** ./src/styles/sections/footer.scss ***!
  \*****************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

eval("{__webpack_require__.r(__webpack_exports__);\n// extracted by mini-css-extract-plugin\n\n\n//# sourceURL=webpack://fabric_and_stitchers/./src/styles/sections/footer.scss?\n}");

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/define property getters */
/******/ 	!function() {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = function(exports, definition) {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	!function() {
/******/ 		__webpack_require__.o = function(obj, prop) { return Object.prototype.hasOwnProperty.call(obj, prop); }
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	!function() {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = function(exports) {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	}();
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module can't be inlined because the eval devtool is used.
/******/ 	var __webpack_exports__ = __webpack_require__("./src/scripts/sections/footer.js");
/******/ 	
/******/ })()
;